
import {IElement, ITextAttributes, ITextSelectionInformation} from 'routes/private/Editor/types';
import { execCommandToSelectedText, updateRenderingTextSegments } from 'utils/textMultiStyling'

export const fontWeightResolver = ( element: IElement, value: boolean, textSelectionInformation?: ITextSelectionInformation ) => {
    if (element.type === "Text") {
        const attributes = execCommandToSelectedText("fontWeight", (element.attributes as ITextAttributes), textSelectionInformation, value);
        element.attributes = updateRenderingTextSegments(attributes);
    }
    return element;
}